import styles from './style.module.css';

const YearConference = () => {
    return (
        <div className={styles.conference_section}>
            <div className={styles.title}>XII Ежегодная конференция московских фтизиатров с международным участием «Различные подходы к профилактике туберкулеза»</div>
            <div className={styles.date}>5 - 6 сентября 2024г.</div>
            <div className={styles.btn_more__area}>
                <a href="/news/45"><div className={styles.btn_more}>Подробнее</div></a>
            </div>
        </div>
    );
}

export default YearConference;
